var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 36,
    height: 36,
    rx: 3.5,
    stroke: "#616161"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5128_27812",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5128_27812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.5C17.25 27.5 16.0792 27.2625 14.9875 26.7875C13.8958 26.3125 12.9458 25.6708 12.1375 24.8625C11.3292 24.0542 10.6875 23.1042 10.2125 22.0125C9.7375 20.9208 9.5 19.75 9.5 18.5C9.5 17.25 9.7375 16.0792 10.2125 14.9875C10.6875 13.8958 11.3292 12.9458 12.1375 12.1375C12.9458 11.3292 13.8958 10.6875 14.9875 10.2125C16.0792 9.7375 17.25 9.5 18.5 9.5C19.8667 9.5 21.1625 9.79167 22.3875 10.375C23.6125 10.9583 24.65 11.7833 25.5 12.85V10.5H27.5V16.5H21.5V14.5H24.25C23.5667 13.5667 22.725 12.8333 21.725 12.3C20.725 11.7667 19.65 11.5 18.5 11.5C16.55 11.5 14.8958 12.1792 13.5375 13.5375C12.1792 14.8958 11.5 16.55 11.5 18.5C11.5 20.45 12.1792 22.1042 13.5375 23.4625C14.8958 24.8208 16.55 25.5 18.5 25.5C20.25 25.5 21.7792 24.9333 23.0875 23.8C24.3958 22.6667 25.1667 21.2333 25.4 19.5H27.45C27.2 21.7833 26.2208 23.6875 24.5125 25.2125C22.8042 26.7375 20.8 27.5 18.5 27.5ZM21.3 22.7L17.5 18.9V13.5H19.5V18.1L22.7 21.3L21.3 22.7Z",
    fill: "#616161"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultHistory);
export default __webpack_public_path__ + "static/media/ResultHistory.93a0718581f71961b7c6eb65473e7334.svg";
export { ForwardRef as ReactComponent };